import { Directive } from 'vue'

const authDirective: Directive = {
    mounted(el, binding, vnode) {
        const userStore = useUserStore()
        const isLoggedIn = userStore.checkIsLogin
        if (!isLoggedIn) {
            el.style.pointerEvents = 'none'
        }
    }
}

export default authDirective